const capitalizeFirst = (str: string = ''): string => {
  return str && str.charAt(0).toUpperCase() + str.slice(1);
};

const capitalizeArrayFirst = (str: string[], seprator: string) => {
  return str.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(seprator);
};

export const stringTransform = { capitalizeFirst, capitalizeArrayFirst };
